module.exports = require("3dmol");


//////////////////
// WEBPACK FOOTER
// external "3dmol"
// module id = 7
// module chunks = 0